import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Button, ModalDelete } from "expano-components";
import { Main, PageLoader } from "components";
import {
  getRemark,
  deleteRemark,
} from "actions/remarks";

import BasicData from "./components/BasicData";

import { ReactComponent as DangerIcon } from "icons/danger.svg";

const canEditRemark = (current_user, remark) =>
  current_user?.is_admin ||
  (current_user?.can_manage_remarks &&
    remark?.reporter?.id === current_user?.id);

const RemarkEdit = ({
  remark,
  current_user,
  getRemark,
  match: { params },
  history,
}) => {
  const [is_open_delete_modal, handleOpenDeleteModal] = useState(false);
  const can_edit = canEditRemark(current_user, remark.data);

  const remark_id = String(params.id);
  const has_loaded_remark =
    remark.data && String(remark.data.id) === remark_id;

  useEffect(() => {
    if (!has_loaded_remark) {
      getRemark(params.id);
    }
  }, [remark_id]);

  if (!has_loaded_remark) {
    if (remark.status === "failure") {
      return <p>Error</p>;
    }

    return <PageLoader />;
  }

  const title = remark.data?.content?.length > 50
    ? `${remark.data.content.slice(0, 50)}...`
    : remark.data?.content;

  return (
    <>
      {is_open_delete_modal && (
        <ModalDelete
          name={title}
          handleClose={() => handleOpenDeleteModal(false)}
          handleDelete={() => {
            deleteRemark(params.id).then(() => {
              handleOpenDeleteModal(false);
              history.push("/remarks");
            });
          }}
        />
      )}
      <Main
        page={{
          name: title || "Edytuj uwagę",
          icon: <DangerIcon />,
          breadcrumbs: [
            { name: "Uwagi", path: "/remarks" },
            { name: title || "Edytuj uwagę" },
          ],
          buttons: can_edit ? (
            <Button
              type="delete"
              text="Usuń uwagę"
              onClick={() => handleOpenDeleteModal(true)}
            />
          ) : null,
        }}>
        <div className="dashboard-wrapper-flex">
          <BasicData />
        </div>
      </Main>
    </>
  );
};

const mapStateToProps = ({ remark, current_user }) => ({
  remark,
  current_user,
});

const mapDispatchToProps = (dispatch) => ({
  getRemark: (id) => dispatch(getRemark(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RemarkEdit);
